import React from 'react'
import { withStyles, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const style = theme => ({
	root: {
		height: '100%',
		'&>*':{
			width: '100%'
		}
	},
	grow: {
		flexGrow: 1,
	}
})

function Column({
	classes,
	children
}) {
	return (
		<Grid
			container
			direction='column'
			className={classes.root}
		>
			{React.Children.map( children, child => {
				if(child === null) return child;
				const props = child.props;
				return (
					<Grid
						item
						className={clsx({
							[classes.grow]: props && props.grow,
						})}
					>
						{child}
					</Grid>
				)
			})}
		</Grid>
	)
}

Column.propTypes = {
	classes: PropTypes.any,
	children: PropTypes.any,
}

Column.defaultProps = {
}

export default withStyles(style)(Column);